export const categoryTileLinkMap = {
    'cat/laptops': { url: '/us-en/shop/vwa/laptops', text: 'view laptops', gtmValue: 'view-laptops' },
    'cat/desktops': { url: '/us-en/shop/vwa/desktops', text: 'view desktops', gtmValue: 'view-desktops' },
    'cat/printers': { url: '/us-en/shop/vwa/printers', text: 'view printers', gtmValue: 'view-printers' },
};